import { defineComponent as n, openBlock as l, createBlock as r, unref as p, mergeProps as m, withCtx as s, createElementVNode as a } from "vue";
import { RevIcon as v } from "@ds/components/Icon";
const u = /* @__PURE__ */ n({
  name: "IconSos",
  __name: "IconSos",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const t = o;
    return (c, e) => (l(), r(p(v), m(t, { "view-box": "0 0 24 24" }), {
      default: s(() => [...e[0] || (e[0] = [
        a("path", { d: "M3.75 9a1.25 1.25 0 1 1 2.5 0 .75.75 0 0 0 1.5 0 2.75 2.75 0 0 0-5.5 0v.114a3.25 3.25 0 0 0 1.527 2.756l1.65 1.032a1.75 1.75 0 0 1 .823 1.484V15a1.25 1.25 0 1 1-2.5 0 .75.75 0 0 0-1.5 0 2.75 2.75 0 1 0 5.5 0v-.614a3.25 3.25 0 0 0-1.527-2.756l-1.65-1.032A1.75 1.75 0 0 1 3.75 9.114V9m14 0a1.25 1.25 0 1 1 2.5 0 .75.75 0 0 0 1.5 0 2.75 2.75 0 1 0-5.5 0v.114a3.25 3.25 0 0 0 1.527 2.756l1.65 1.032a1.75 1.75 0 0 1 .823 1.484V15a1.25 1.25 0 1 1-2.5 0 .75.75 0 0 0-1.5 0 2.75 2.75 0 1 0 5.5 0v-.614a3.25 3.25 0 0 0-1.527-2.756l-1.65-1.032a1.75 1.75 0 0 1-.823-1.484V9" }, null, -1),
        a("path", {
          "fill-rule": "evenodd",
          d: "M14.75 9v6a2.75 2.75 0 1 1-5.5 0V9a2.75 2.75 0 1 1 5.5 0M12 7.75A1.25 1.25 0 0 0 10.75 9v6a1.25 1.25 0 1 0 2.5 0V9A1.25 1.25 0 0 0 12 7.75",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  u as default
};
